import React from 'react'
import PropTypes from 'prop-types'
import { TextField, Typography } from '@material-ui/core'
import useStyles from './styles'

const CommentText = ({
  text,
  isEditing,
  editValue,
  onEditChange,
  onKeyDown,
  disabled,
}) => {
  const classes = useStyles()

  if (isEditing) {
    return (
      <TextField
        value={editValue}
        onChange={(e) => onEditChange(e.target.value)}
        onKeyDown={onKeyDown}
        variant="outlined"
        size="small"
        fullWidth
        multiline
        autoFocus
        disabled={disabled}
      />
    )
  }

  return <Typography className={classes.commentText}>{text}</Typography>
}

CommentText.propTypes = {
  text: PropTypes.string.isRequired,
  isEditing: PropTypes.bool,
  editValue: PropTypes.string,
  onEditChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
}

CommentText.defaultProps = {
  isEditing: false,
  editValue: '',
  onEditChange: () => {},
  onKeyDown: () => {},
  disabled: false,
}

export default CommentText
